<template>
  <!-- eslint-disable max-len -->
  <div class="el-body profile">
    <ep-layout/>
    <div class="el-dialog" v-if="importIdDialog">
      <div class="el-dialog__container">
        <div class="el-panel">
          <div class="el-toolbar"><h2>{{$t('profile.docs.import.id')}}</h2></div>
          <div class="import-id-container">
            <label class="id-selection">
              <input
                  type="file"
                  ref="file"
                  accept=".pdf"
                  @change.stop="handleFileIdUpload($event,'IdentityCard', 'CIDT', false)"
                  class="ep-input-group--upload"
              />
              <template>
                <p>{{$t('profile.docs.import.id.single')}}</p>
                <img src="../../assets/img/id-icon.svg" alt="id-icon">
              </template>
            </label>
            <span class="separator"/>
            <label class="id-selection">
              <input
                  type="file"
                  ref="file"
                  multiple
                  accept=".pdf"
                  @change.stop="handleFileIdUpload($event, 'IdentityCard', 'CIDT', true)"
                  class="ep-input-group--upload"
              />
              <template>
                <p>{{$t('profile.docs.import.id.multiple')}}</p>
                <div><img class="img1" src="../../assets/img/id-icon.svg" alt="id-icon"><img class="img2" src="../../assets/img/id-icon.svg" alt="id-icon"></div>
                <div class="id-selection_error-message" v-if="shouldDisplayErrorMessage">{{$t('profile.docs.import.id.error')}}</div>
              </template>
            </label>
          </div>
          <div class="el-toolbar el-toolbar--bottom">
            <button class="el-button el-button--inverted" @click="importIdDialog = false">{{$t('profile.docs.import.id.cancel')}}</button></div>
        </div>
      </div>
    </div>
    <el-aside-menu :isOpen="asideMenusIsOpened">
      <!-- top part without scroll -->
      <el-aside-menu-sticky>
        <el-aside-menu-title v-if="user">
          <span class="icon-espace_perso"></span>&nbsp;
          <span>{{ user.firstname }} {{ user.lastname }}</span>
        </el-aside-menu-title>
      </el-aside-menu-sticky>

      <el-aside-menu-tab
        v-for="option in options"
        :class="{ active: option.text === selected }"
        :key="option.text"
        @click.native="selected = option.text"
        tabindex="0"
        :aria-label="option.text"
      >
        <span v-if="option.text !== $t('profile.accord') || Status.canSelectAgreement">
          <span :class="option.icon"></span>
          {{ option.text }}
          <span :class="['ep-badge-indicator', { active: Status.hasBPE }]" v-if="option.text === $t('profile.accord')"></span>
        </span>
      </el-aside-menu-tab>
    </el-aside-menu>
    <div class="el-panel el-panel--aside-menu">
      <el-toolbar :sticky="true">
        <h2 class="el-main-title">{{ selected }}</h2>

        <el-toolbar-spacer />
      </el-toolbar>

      <EmailDomainDialog
        v-if="emailDomainDialogOpened"
        :mail="userData.email"
        @close="emailDomainDialogOpened = false"
        @sendValidationCode="sendEmailValidationCode(); emailDomainDialogOpened = false"
      />

      <div v-if="selected === $t('profile.parameters')">
        <el-expansion-panel ref="info" :text="$t('profile.information')">
          <form @submit.prevent="updateUserInfo()">
            <div
              v-for="field in Info"
              :key="field.type"
              :class="{ 'ep-input-group--small-size': field.type !== 'address', 'ep-input-group': field.type === 'address' }"
            >
              <label class="el-input-group__label">{{ field.label }}</label>
              <input
                v-if="field.type === 'birthDate'"
                class="el-input-group__input"
                required="required"
                type="text"
                v-model="birthDate"
                :placeholder="field.placeholder"
                pattern="^([0-2][0-9]|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d\d$"
                :readonly="userData.isLinkedToFranceConnect"
              />
              <input
                  v-else
                  class="el-input-group__input"
                  required="required"
                  type="text"
                  v-model="userData[field.type]"
                  :placeholder="field.placeholder"
                  :pattern="field.pattern"
                  :readonly="field.readonly"
              />
              <div v-if="field.type === 'email' && isEmailYvelines(userData[field.type])" style="text-align: left; font-size: 0.9rem; color: red; margin: 1rem; font-weight: bold;">{{ $t('profile.update.email.block', { email: userData[field.type] }) }}</div>
            </div>
            <div class="ep-button--panel-bottom">
              <button type="submit" v-if="selected === $t('profile.parameters') && !isEmailYvelines(userData.email)" class="el-button">{{ $t('profile.save') }}</button>

              <button type="button" v-if="selected === $t('profile.parameters')" class="el-button el-button--inverted" @click.prevent="cancelInfo()">
                {{ $t('profile.cancel') }}
              </button>
            </div>
          </form>
        </el-expansion-panel>
        <el-expansion-panel ref="panelPass" :text="$t('profile.password')" v-if="!this.userData.isLinkedToFranceConnect">
          <UpdatePassword
            @submit="handleUpdatePassword"
            @cancel="cancelPass"
            :smallSize="true"
            :submitButtonLabel="$t('profile.save')"
            :cancelButtonLabel="$t('profile.cancel')"
          />
        </el-expansion-panel>

        <el-expansion-panel  v-if="this.userData.isLinkedToFranceConnect" ref="panelFranceConnect" :text="$t('profile.franceconnect')">
          <div style="height: 240px">
            <div>
              Votre connexion FranceConnect est active.<br /><br />
              <div class="ep-button--panel-bottom">
                <button class="el-button el-button" @click="disableFranceConnectLink">
                  {{ $t('button.disable') }}
                </button>
              </div>
            </div>
          </div>
        </el-expansion-panel>
        <el-expansion-panel :text="$t('profile.adminDocs')">
          <el-card v-for="(doc, index) in Docs" :key="doc.type">
            <el-card-icon :class="doc.icon" v-if="doc.typeCode !== 'TSMT'" />
            <div v-else class="text-center">
              <img src="../../assets/img/icon_will.svg" alt="will" />
            </div>
            <b>
              {{ doc.text.slice(0, 18) }}
              <span v-if="doc.text.length > 18">...</span>
            </b>
            <button class="el-button el-button--small" v-if="doc.file !== null" @click="CheckinDocs(doc.file)">{{ $t('profile.docs.check') }}</button>

            <button
                class="el-button el-button--small"
                v-if="doc.typeCode === 'CIDT' && doc.file === null"
                @click="importIdDialog = true"
            >{{$t('profile.docs.import')}}</button>
            <label
              class="el-button el-button--small ep-input-group--center"
              v-if="doc.file === null && doc.typeCode !== 'CIDT'"
            >
              <input
                type="file"
                ref="file"
                accept=".pdf"
                @change.stop="handleFileUpload($event, doc.typeDescription, doc.typeCode)"
                class="ep-input-group--upload"
              />
              {{ $t('profile.docs.import') }}
            </label>
            <el-card-hover-panel v-if="doc.file !== null">
              <el-card-hover-button
                class="icon-supprime"
                @click.native="deleteFile(doc.file.id,index)"
              />
            </el-card-hover-panel>
          </el-card>
        </el-expansion-panel>

        <!--modal update user -->
        <div class="el-dialog" v-show='modalVisible'>
          <div class="el-dialog__container">
            <div class="el-panel">
              <div @click="showModal" class="ep-dialog__icon">x</div>
              <form v-if="mode.validationEmailMode" v-on:submit.prevent="verifyEmailValidationCode()">
                <h2 className="el-title" class="mt-4">{{$t('profile.validation.mail.code.title')}}</h2>
                <div class="mt-4 mb-4">
                  <label class="el-input-group__label">{{$t('profile.validation.mail.code.label')}}</label>
                  <input
                    v-model="verificationMailCode"
                    class="el-input-group__input"
                    required
                    :placeholder="$t('profile.validation.mail.code.placeholder')"
                  />
                </div>
                <button
                  class="el-toolbar el-button el-toolbar--bottom "
                >{{ $t('button.validate')}}</button>
              </form>
              <form v-else v-on:submit.prevent="verifyPassword()">
                <h2 className="el-title" class="mt-4">{{$t('profile.password.modal.title')}}</h2>
                <div class="mt-4 mb-4">
                  <label class="el-input-group__label">{{$t('profile.current.placeholder')}}</label>
                  <input
                    v-model="verifPass"
                    class="el-input-group__input"
                    required
                    :placeholder="$t('profile.current.placeholder')"
                    type="password"
                  />
                </div>
                <button
                  class="el-toolbar el-button el-toolbar--bottom "
                >{{ $t('button.validate')}}</button>
              </form>
            </div>
          </div>
        </div>

      </div>
      <div v-if="selected === $t('profile.services')">
        <el-expansion-panel v-if="!isMIPIH" ref="Code" :text="Service[1]">
          <br />
          <br />
          {{ $t('services.retrieve.text') }}
          <br />
          <br />
          <br />
          <label class="el-input-group__label">{{ $t('services.retrieve.phone') }}</label>
          <div class="ep-input-group--sign">
            <input class="el-input-group__input" v-model="mobile" :placeholder="servPlaceholder[4]" />
            <br />
          </div>

          <el-toolbar :sticky="true">
            <el-toolbar-spacer />
            <button class="el-button" @click="retrieveCode()">{{ $t('service.validate') }}</button>
          </el-toolbar>
        </el-expansion-panel>
        <el-expansion-panel ref="export" :text="$t('profile.digitalSafe')">
          <p class="el-text" v-html="$t('profile.export.text')"></p>
          <br />
          <el-toolbar :sticky="true">
            <el-toolbar-spacer />
            <button class="el-button" @click="exportSafeboxFromProfile()">
              {{ $t('profile.digitalSafe') }}
            </button>
          </el-toolbar>
        </el-expansion-panel>

        <!-- <div class="el-toolbar">
          <div class="el-toolbar__spacer"></div>
          <button class="el-button">+</button>
          <div class="el-toolbar__spacer"></div>
        </div>-->
      </div>
      <div v-if="selected === $t('profile.accord') && Status.canSelectAgreement">
        <br />
        <br />
        <template v-if="Status.hasBPE">{{ $t('profile.accord.dematerialization.deactivate') }}</template>
        <template v-else>{{ $t('profile.accord.dematerialization.activate') }}</template>
        <br />
        <br />
        <br />
        <label class="el-input-group__label">{{ $t('profile.signatureCode') }}</label>
        <div class="ep-input-group--sign">
          <input class="el-input-group__input" v-model="Signature" :placeholder="servPlaceholder[3]" />
          <br />

          <!-- <p class="ep-warning" v-if="Signature.length === 0">{{ $t('profile.services.required')}}</p> -->
        </div>

        <p class="el-link" @click="forgotten">{{ $t('profile.signatureCode.forgotten') }}</p>

        <el-toolbar :sticky="true">
          <el-toolbar-spacer />
          <button v-if="!Status.hasBPE" class="el-button" @click="activate()">{{ $t('profile.activate') }}</button>
          <button v-else class="el-button" :disabled="Signature.length === 0" @click="desactivate()">
            {{ $t('profile.desactivate') }}
          </button>
        </el-toolbar>
      </div>
      <div v-else-if="selected === $t('profile.accord') && !Status.canSelectAgreement">
        <br />
        <br />
        <br />
        {{ $t('profile.rights') }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
// import { uuid } from 'vue-uuid';
import EpLayout from '@/layouts/Default.vue';
import UpdatePassword from '@/components/password/UpdatePassword.vue';
import { PDFDocument } from 'pdf-lib';
import auth from '../../utils/auth';
import unauthorizedDomains from '../../utils/yvelinesDomains.json';
import popularEmailDomains from '../../utils/mailDomains.json';
import EmailDomainDialog from '../../components/dialog/EmailDomainDialog.vue';
import trackingServices from '../../plugins/posthog';

export default {
  name: 'profile-index',
  components: {
    EpLayout,
    EmailDomainDialog,
    UpdatePassword,
  },

  data() {
    return {
      birthDate: '',
      shouldDisplayErrorMessage: false,
      importIdDialog: false,
      id_recto: null,
      id_verso: null,
      mobile: null,
      n: null,
      AdminFolder: {},
      file: null,
      warn: false,
      Signature: '',
      site: null,
      log: null,
      pass: null,
      servPlaceholder: [
        this.$i18n.t('profile.services.site.placeholder'),
        this.$i18n.t('profile.services.username.placeholder'),
        this.$i18n.t('profile.services.password.placeholder'),
        this.$i18n.t('profile.signatureCode'),
        this.$i18n.t('services.retrieve.phone.placeholder'),
      ],
      add: true,
      revealState: [],
      showState: [],
      adding: false,
      match: null,
      password: {
        newPassword: '',
        similar: '',
      },
      // franceConnectClbDatas: undefined,
      selected: '',
      confirm: this.$i18n.t('profile.current.confirm.placeholder'),
      options: [
        {
          text: this.$i18n.t('profile.parameters'),
          icon: 'icon-setting',
          show: true,
        },
        {
          text: this.$i18n.t('profile.services'),
          icon: 'icon-services',
          show: true,
        },
        {
          text: this.$i18n.t('profile.accord'),
          icon: 'icon-brouillon',
          show: true,
        },
      ],

      showInput: false,
      Info: [
        {
          label: this.$i18n.t('profile.fname'),
          type: 'firstname',
          placeholder: this.$i18n.t('profile.fname.placeholder'),
          readonly: false,
        },
        {
          label: this.$i18n.t('profile.lname'),
          type: 'lastname',
          placeholder: this.$i18n.t('profile.lname.placeholder'),
          readonly: false,
        },
        {
          label: this.$i18n.t('profile.Email'),
          type: 'email',
          placeholder: this.$i18n.t('profile.Email.placeholder'),
        },
        {
          label: this.$i18n.t('profile.phone'),
          type: 'phone',
          placeholder: this.$i18n.t('profile.phone.placeholder'),
          pattern: '[0-9]{10,11}',
        },
        {
          label: this.$i18n.t('profile.birthDate.label'),
          type: 'birthDate',
          placeholder: this.$i18n.t('profile.birthDate.placeholder'),
          readonly: false,
        },
        {
          label: this.$i18n.t('profile.address'),
          type: 'address',
          placeholder: this.$i18n.t('profile.address.placeholder'),
        },
        {
          label: this.$i18n.t('profile.zip'),
          type: 'zipCode',
          placeholder: this.$i18n.t('profile.zip.placeholder'),
          pattern: '[0-9]{5}',
        },
        {
          label: this.$i18n.t('profile.City'),
          type: 'town',
          placeholder: this.$i18n.t('profile.City.placeholder'),
        },
      ],
      Service: [this.$i18n.t('service.login'), this.$i18n.t('service.retrieveCode')],

      Pass: [
        {
          label: this.$i18n.t('profile.current'),
          type: 'actualPassword',
          placeholder: this.$i18n.t('profile.current.placeholder'),
        },
        {
          label: '',
          type: '',
          placeholder: '',
        },
      ],
      verifPass: '',
      verifEmail: '',
      modalVisible: false,
      mode: {
        validationEmailMode: false,
        validationPasswordMode: false,
      },
      verificationMailCode: null,
      userData: {},
      Docs: [
        {
          icon: 'icon-id',
          type: "Carte d'identité",
          text: this.$i18n.t('profile.docs.identity'),
          file: null,
          typeDescription: 'IdentityCard',
          typeCode: 'CIDT',
        },
        {
          icon: 'icon-mariage',
          type: "Acte d'état civil",
          text: this.$i18n.t('profile.docs.status'),
          file: null,
          typeDescription: 'ActeCivil',
          typeCode: 'AECV',
        },
        {
          icon: 'icon-diploma',
          type: 'Diplome',
          text: this.$i18n.t('profile.docs.diplomas'),
          file: null,
          typeDescription: 'Diploma',
          typeCode: 'DPLM',
        },
        {
          icon: 'icon-driving_licence',
          type: 'Permis de conduire',
          text: this.$i18n.t('profile.docs.drive'),
          file: null,
          typeDescription: 'DriverLicence',
          typeCode: 'PECO',
        },
        {
          icon: 'icon-birth_certificate',
          type: 'Acte de naissance',
          text: this.$i18n.t('profile.docs.birth'),
          file: null,
          typeDescription: 'BirthAct',
          typeCode: 'ACNS',
        },
        {
          icon: 'icon-passport',
          type: 'Passeport',
          text: this.$i18n.t('profile.docs.passport'),
          file: null,
          typeDescription: 'Passeport',
          typeCode: 'PSPR',
        },
        {
          icon: 'icon-testament',
          type: 'Testament',
          text: this.$i18n.t('profile.docs.testament'),
          file: null,
          typeDescription: 'Testament',
          typeCode: 'TSMT',
        },
        {
          icon: 'icon-criminal_record',
          type: 'Extrait de casier judiciaire',
          text: this.$i18n.t('profile.docs.record'),
          file: null,
          typeDescription: 'CasierJudiciaire',
          typeCode: 'ECJD',
        },
      ],
      Status: {
        canSelectAgreement: undefined,
        hasBPE: undefined,
      },
      AdminFolderId: null,
      emailDomainDialogOpened: false,
    };
  },
  computed: {
    ...mapGetters({
      asideMenusIsOpened: 'application/menusAreOpened',
      user: 'user/user',
      adminDocs: 'user/adminDocs',
      services: 'user/services',
      adminDocid: 'user/adminDocid',
      petalCounter: 'user/petalCounter',
      dematStatus: 'user/dematStatus',
    }),
    ...mapState({
      all: state => state.documents.all,
      isMIPIH: state => state.auth.isMIPIH,
    }),
  },

  methods: {
    ...mapActions({
      getUserInfo: 'user/getUserInfo',
      getIdentityDocs: 'user/getIdentityDocs',
      update: 'user/update',
      updatePassword: 'user/updatePassword',
      getServices: 'user/getServices',
      updateService: 'user/updateService',
      deleteService: 'user/deleteService',
      addService: 'user/addService',
      enablePaySlipDemat: 'user/enablePaySlipDemat',
      disablePaySlipDemat: 'user/disablePaySlipDemat',
      retrieveSignatureCode: 'user/retrieveSignatureCode',
      fetchFilesAndFolders: 'documents/all',
      setAdminDocId: 'user/setAdminDocId',
      setPetalsCounter: 'user/setPetalsCounter',
      setDematStatus: 'user/setDematStatus',
      deleteMyFile: 'documents/deleteMyFile',
      create: 'documents/create',
      exportSafebox: 'user/exportSafebox',
      updateEmail: 'user/updateEmail',
      storeLoadFCAuthSub: 'user/loadFCAuthSub',
      storeDisableFranceConnectLink: 'user/disableFranceConnectLink',
      storeSendEmailValidationCode: 'user/sendEmailValidationCode',
      storeVerifyEmailValidationCode: 'user/verifyEmailValidationCode',
    }),

    isEmailYvelines(email) {
      return unauthorizedDomains.some(subStr => email.toLowerCase().includes(subStr));
    },
    exportSafeboxFromProfile() {
      trackingServices.exportSafebox();
      this.exportSafebox();
    },
    forgotten() {
      this.selected = this.options[1].text;
      this.$nextTick(() => {
        this.$refs.Code.toggle();
      });
    },
    CheckinDocs(doc) {
      this.$router.push({
        name: 'profile.details',
        params: { item: doc },
      });
    },
    activate() {
      if (this.Signature !== '') {
        this.enablePaySlipDemat(this.Signature).then(() => {
          this.setDematStatus().then(() => {
            this.Status = this.dematStatus;
            this.Signature = '';
            trackingServices.activateAgreement();
          });
        });
      }
    },
    desactivate() {
      if (this.Signature !== '') {
        this.disablePaySlipDemat(this.Signature).then(() => {
          this.setDematStatus().then(() => {
            this.Status = this.dematStatus;
            this.Signature = '';
            trackingServices.disabledAgreement();
          });
        });
      }
    },

    async handleFileUpload(event, typeDescription, typeCode) {
      this.submitFile(typeDescription, typeCode, event.target.files[0]);
    },

    async handleFileIdUpload(event, typeDescription, typeCode, multiple) {
      if (multiple) {
        if (event.target.files.length !== 2) {
          this.shouldDisplayErrorMessage = true;
          return;
        }
        const file1 = event.target.files[0];
        this.id_recto = await this.readFileAsArrayBuffer(file1);
        const file2 = event.target.files[1];
        this.id_verso = await this.readFileAsArrayBuffer(file2);
        this.submitFile(typeDescription, typeCode, await this.mergePdfs());
      } else {
        this.submitFile(typeDescription, typeCode, event.target.files[0]);
      }
      this.importIdDialog = false;
    },

    readFileAsArrayBuffer(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject(reader.error);
        reader.readAsArrayBuffer(file);
      });
    },

    async mergePdfs() {
      if (this.id_recto && this.id_verso) {
        const pdf1Doc = await PDFDocument.load(this.id_recto);
        const pdf2Doc = await PDFDocument.load(this.id_verso);
        const mergedPdf = await PDFDocument.create();

        const pdf1Pages = await mergedPdf.copyPages(pdf1Doc, pdf1Doc.getPageIndices());
        const pdf2Pages = await mergedPdf.copyPages(pdf2Doc, pdf2Doc.getPageIndices());

        pdf1Pages.forEach(page => mergedPdf.addPage(page));
        pdf2Pages.forEach(page => mergedPdf.addPage(page));

        const mergedPdfBytes = await mergedPdf.save();
        const blob = new Blob([mergedPdfBytes], { type: 'application/pdf' });
        return new File([blob], 'carte_identite.pdf', { type: blob.type });
      }
      return null;
    },

    cancelInfo() {
      this.$refs.info.toggle();
    },
    cancelPass() {
      this.$refs.panelPass.toggle();
    },
    submitFile(description, code, file) {
      const content = {
        json: {
          sessionId: this.$store.state.auth.session.token,
          description: file.name.split('\\').pop(), // f.value.replace(/\.[^/.]+$/, ''),
          folderId: this.adminDocid,
          extension: file.name.split('.').pop(),
          typeCode: code,
          typeDescription: description,
          isUserProfileDoc: true,
        },
        fileContent: file,
      };
      this.create(content)
        .then(() => this.getIdentityDocs())
        .then(() => {
          for (let i = 0; i < this.adminDocs.length; i += 1) {
            for (let j = 0; j < this.Docs.length; j += 1) {
              // eslint-disable-next-line max-len
              if (this.Docs[j].typeCode.toLowerCase().trim() === this.adminDocs[i].typeCode.toLowerCase().trim()) {
                this.Docs[j].file = this.adminDocs[i];
              }
            }
          }
        })
        .then(() => this.fetchFilesAndFolders());
    },

    // method used to toggle the modal
    showModal() {
      this.modalVisible = !this.modalVisible;
      this.verifPass = '';
    },
    deleteFile(fileId, index) {
      this.deleteMyFile(fileId)
        .then(() => this.getIdentityDocs())
        .then(() => {
          this.Docs[index].file = null;
        });
    },
    retrieveCode() {
      if (this.mobile > 0) {
        const o = { phone: this.mobile };
        this.$refs.Code.toggle();
        this.retrieveSignatureCode(o);
        this.mobile = null;
      }
    },

    noCustomValidityMessage(event) {
      event.target.setCustomValidity('');
    },

    efolia() {
      window.open('https://portail.efolia.fr', '_blank');
    },
    verifyEmailValidationCode() {
      this.storeVerifyEmailValidationCode(
        { userId: this.userData.id, code: this.verificationMailCode.replace(/ /g, '') },
      ).then(() => {
        this.mode.validationEmailMode = false;
        this.mode.validationPasswordMode = true;
      });
    },

    isEmailDomainPopular() {
      const domain = this.userData.email.substr(this.userData.email.indexOf('@') + 1);
      if (!popularEmailDomains.find((item => item === domain))) {
        this.emailDomainDialogOpened = true;
        return false;
      }
      return true;
    },

    sendEmailValidationCode() {
      this.storeSendEmailValidationCode(
        { userId: this.userData.id, email: this.userData.email },
      ).then(() => {
        this.mode.validationEmailMode = true;
        this.showModal();
      });
    },

    updateUserInfo(passverified) {
      if (this.verifEmail !== this.userData.email && passverified !== true) {
        if (this.isEmailDomainPopular()) {
          this.sendEmailValidationCode();
        }
      } else {
        this.verifEmail = this.userData.email;
        const profile = {
          firstname: this.userData.firstname,
          lastname: this.userData.lastname,
          address: this.userData.address,
          zipCode: this.userData.zipCode,
          town: this.userData.town,
          phone: this.userData.phone,
          birthDate: this.birthDate.split(' ')[0].split('/').reverse().join('-'),
        };
        this.update(profile).then(() => {
          this.getUserInfo();
        });
      }
    },

    // method used for checking the user password in order to update the email
    verifyPassword() {
      const payload = {
        email: this.userData.email,
        password: this.verifPass,
      };
      this.updateEmail(payload).then(() => {
        this.showModal();
        this.updateUserInfo(true);
      });
    },

    adminDocTreatment() {
      this.getIdentityDocs().then(() => {
        for (let i = 0; i < this.adminDocs.length; i += 1) {
          for (let j = 0; j < this.Docs.length; j += 1) {
            // eslint-disable-next-line max-len
            if (this.Docs[j].typeCode.toLowerCase().trim() === this.adminDocs[i].typeCode.toLowerCase().trim()) {
              this.Docs[j].file = this.adminDocs[i];
            }
          }
        }
      });
    },

    // redirectToFranceConnectAuth() {
    //   auth.getConf().then((response) => {
    //     let fcUrl = `${response.CONF.FRANCE_CONNECT_HOST}/api/v1/authorize?`;
    //     fcUrl += `client_id=${response.CONF.FRANCE_CONNECT_CLIENT_ID}`;
    //     fcUrl += `&redirect_uri=${window.location.origin}/profile/fc-callback`;
    //     fcUrl += `&response_type=code&scope=openid&state=${uuid.v4()}&nonce=${this.user.id.substr(0, 10)}`;
    //     fcUrl += '&acr_values=eidas1';
    //     document.location = fcUrl;
    //   });
    // },
    // handleFranceConnectClb() {
    //   this.franceConnectClbDatas = {
    //     code: this.$route.query.code,
    //     redirectUri: `${window.location.origin}/profile/fc-callback`,
    //   };
    //   this.storeLoadFCAuthSub(this.franceConnectClbDatas)
    //     .then(() => {
    //       this.franceConnectClbDatas.subRegistered = true;
    //       this.userData.isLinkedToFranceConnect = true;
    //     })
    //     .catch(() => {
    //       this.franceConnectClbDatas.subRegistered = false;
    //     });
    // },
    disableFranceConnectLink() {
      this.storeDisableFranceConnectLink().then(() => {
        this.userData.isLinkedToFranceConnect = false;
      });
    },
    handleUpdatePassword({ newPassword, actualPassword }) {
      this.updatePassword({ newp: newPassword, actual: actualPassword });
      this.$refs.panelPass.toggle();
    },
  },

  async mounted() {
    console.log(this.servPlaceholder);
    this.selected = this.options[0].text;
    this.fetchFilesAndFolders().then(() => {
      const administrativeFolder = this.all.find(x => x.code === 'administrative');
      this.setAdminDocId({ content: administrativeFolder ? administrativeFolder.folderId : '' }).then(() => {
        this.adminDocTreatment();
      });
    });

    if (!this.user) {
      await this.getUserInfo();
    }

    this.Info = this.Info.map((info) => {
      const newInfo = info;
      if (info.type === 'firstname' || info.type === 'lastname') {
        newInfo.readonly = this.user.isLinkedToFranceConnect;
      }
      return newInfo;
    });

    if (!this.services.length) {
      this.getServices();
    }
    if (!this.petalCounter) {
      this.setPetalsCounter();
    }
    this.revealState = Array(this.services.length).fill(false);
    this.showState = Array(this.services.length).fill(false);
    if (this.dematStatus) {
      this.Status = this.dematStatus;
      this.options[2].show = this.Status.canSelectAgreement;
    } else {
      this.setDematStatus().then(() => {
        this.Status = this.dematStatus;
        this.options[2].show = this.Status.canSelectAgreement;
      });
    }
    auth.getConf().then((response) => {
      if (response.CONF.MIPIH) {
        this.options.pop();
      }
    });
    // data used for updating user profile
    this.verifEmail = this.user.email;
    this.userData = { ...this.user };
    this.birthDate = this.user.birthDate.split(' ')[0].split('-').reverse().join('/');

    // if (this.isFcCallback) {
    //   this.handleFranceConnectClb();
    // }
  },
};
</script>
<style lang="scss" scoped>
.password-rules {
  margin: 1rem 0 0 0.5rem;

  .edp-rules {
    margin-left: 0.5rem;
  }

  div {
    display: flex;
    align-items: flex-end;
  }

  .edp-icon {
    margin: 0 0.75rem;
  }

  .valid {
    color: green;
    font-weight: bold;
  }

  li {
    color: red;
    transition: color 0.3s;
    list-style: none;
  }
}
</style>
